/** Per-program accent for InfoCard rotating border + title hover reveal */
const PROGRAM_ACCENTS: Record<string, string> = {
  healthcare: "#3b82f6",
  education: "#059669",
  goshala: "#d97706",
  "blood-donation": "#ef4444",
  "blanket-destitution": "#6366f1",
  "skill-development": "#0d9488",
};

const FALLBACK_ACCENTS = [
  "var(--charity-green)",
  "var(--charity-gold)",
  "var(--programs-green)",
];

export function getProgramInfoCardAccent(slug: string, index = 0): string {
  return PROGRAM_ACCENTS[slug] ?? FALLBACK_ACCENTS[index % FALLBACK_ACCENTS.length];
}
